import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	stroke: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "M13 10V3L4 14h7v7l9-11h-7z"
	})
});
export default SvgLightning;
